import { defaultPaddingLeft, mobileDefaultPaddingLeft } from '../../../../../../../../../constants/sizes';
import { appConfig } from '../../../../../../../../../config/customization';
import Device from '../../../../../../../../../constants/deviceSizes';

const container = {
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  justifyContent: 'flex-start',
  alignItems: 'flex-start'
};

export default {
  colorContainer: {
    ...container,
    width: '100%',
    padding: `5px ${defaultPaddingLeft}px 10px`,
    [Device.mobile]: {
      padding: `5px ${mobileDefaultPaddingLeft}px 10px`
    }
  },
  lineContainer: {
    ...container,
    width: `calc(100% - ${defaultPaddingLeft}px)`,
    margin: '12px 0px',
    padding: `8px 18px`,
    border: `1px solid ${appConfig.colors.bordersGray}`,
    borderRadius: 10,
    [Device.mobile]: {
      width: `calc(100% - ${mobileDefaultPaddingLeft}px)`,
      padding: 8
    }
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    width: appConfig.bills.downloadIcon ? '90%' : '100%',
    flexWrap: 'wrap',
    marginTop: 10,
    [Device.mobile]: {
      width: '100%',
      flexDirection: 'column'
    }
  },
  header: {
    padding: '5px 0px 10px',
    width: '100%',
    height: 'auto'
  },
  titleDetail: {
    marginRight: 10
  },
  tag: {
    margin: '0px 10px',
    padding: '0px 5px',
    height: 25
  },
  detailsWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [Device.mobile]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  downloadButton: {
    height: 23,
    padding: '0px 15px',
    marginBottom: 5
  },
  sectionTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between'
  }
};
